import React, { useState, useEffect } from 'react';

import editIcon from './../../../../Assets/icons/Un-Checkbox.svg';

import { useNavigate } from 'react-router-dom';

import { FiDownload } from "react-icons/fi";
import CustomTable from '../../../customComponents/CustomTable';
import axiosInstance from '../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../routes/routes';
import Loader from '../../../customComponents/CustomLoader';
import SearchInput from '../../../customComponents/CustomSearch/SearchInput';
import ListLogisticsFilters from '../../Logistics/LogisticsFilter';


const GracePeriodList = () => {
  const [productData, setProductData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [filters, setFilters] = useState({});
  const [totalActive, setTotalActive] = useState(0)
  const [loading, setLoading] = useState(true);
  const [totalInactive, setTotalInactive] = useState(0)
      const [modelOptions, setModelOptions ] = useState([])
        const [variantOptions, setVariantOptions] = useState([]);

    const [filterFormData, setFilterFormData] = useState({});
    const [validationErrors, setValidationErrors] = useState({});

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");


  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    // Format to YYYY-MM-DD without timezone influence
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};


  const fetchProductList = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;
    try {
      setLoading(true)
      const response = await axiosInstance.post('/grace-warranty/list', {
        // orderBy: 'product_id desc',
        // page,
        // pageSize,
        // searchText: searchTerm
        // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
        // toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : null,
        fromDate: formatDate(allfilteredData?.fromDate),
        toDate: formatDate(allfilteredData?.toDate),
        modelId: allfilteredData?.modelId ? allfilteredData?.modelId : null,
        variantId: allfilteredData?.variantId ? allfilteredData?.variantId : null,
        searchText: searchTerm || null,
        orderBy: "id desc",
        pageSize,
        page
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1 + page * pageSize
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

      setTotalData(totalCount)
      setTotalActive(totalAct)
      setTotalInactive(totalInac)

      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setProductData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));

    } catch (error) {
      console.error('Error fetching product list:', error);
    }
    finally {
      setLoading(false)
    }
  };

  const fetchProductData = async () => {
    const allfilteredData = filters;
    const payload = {

      poStatus: 0,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
      toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : null,
      modelId: allfilteredData?.modelId ? allfilteredData?.modelId : null,
      variantId: allfilteredData?.variantId ? allfilteredData?.variantId : null,
      searchText: searchTerm,
      orderBy: "",

    }
    console.log('filteresdata', payload);

    try {
      // setTableLoader(true)
      const response = await axiosInstance.post(
        "/product/product-report-excel", payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // setTableLoader(false)
      // const formattedData = response?.data?.data?.data.map((item, index) => ({
      //     ...item,
      //     item_name: item.item_name || "--",
      //     model_name: item.model_name || "--",
      //     variant_name: item.variant_name || "--",
      //     logInDateTime: item.logInDateTime 
      //     ? new Date(item.logInDateTime)
      //         .toLocaleString("en-GB", { hour12: false }) // 24-hour format
      //         .replace(/\//g, "-") // Convert date separator to "-"
      //     : "--"

      // }))
      // const totalRecordsData = response?.data?.data?.totalRecords
      // setTotalRecords(totalRecordsData);

      // setVinNoData(formattedData)

    } catch (error) {
      console.error("Error fetching business partners:", error);
      // setIsSearchPerformed(false);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchProductList(newPage);
  };

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      // dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : dealerId,
      // state_id: "",
      // services_by: "",
      // servicesValue_Id: "",
      poStatus: 0,
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      // toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : "",
      fromDate: formatDate(allfilteredData?.fromDate),
        toDate: formatDate(allfilteredData?.toDate),
      searchText: searchTerm,
      orderBy: "",
    };

    try {
      const response = await axiosInstance.post("/product/product-report-excel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "text/csv" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "product.csv";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };

  const TABLE_HEADERS = [
    // "Sr No.",
    // "Product ID",
    "Vin Num",
    "Warranty From",
    "Warranty To",
    "Warranty Days",
    "Status",
    "Remark"
    // "Action"
  ];

  const keyMapping = {
    // "Sr No.": "Sr No.",
    // "Product ID": "product_id",
    "Vin Num": "vinNum",
    "Warranty From": "warrantyFrom",
    "Warranty To": "warrantyTo",
    "Warranty Days": "warrantyDays",
    "Status":"status",
    "Remark":"remark",
    "Action": [
      { type: "edit", icon: editIcon, label: "Edit" },
    ]
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchProductList();
    }
  }, [searchTerm]);
  const handleEdit = (rowData) => {

    navigate(`${ROUTES_NAVIGATION.EDITPRODUCT}`, { state: { data: rowData } });
  }

  useEffect(() => {
    fetchModelOptions()
  },[])

  const fetchModelOptions = async (makeId) => {
    try {
      const payload = {
        orderBy: "model_id desc",
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post("/model/ddlmodel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setModelOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    const modelId = filterFormData.modelId
    console.log(modelId, "MODELiD")

    if(modelId){
      fetchVariantDropdown(modelId)
    }

  },[filterFormData.modelId])

  const fetchVariantDropdown = async (modelId) => {
    try {
      const payload = {
        // orderBy: "model_id desc",
        // page: 0,
        // pageSize: 100,
        modelId: modelId
      };

      const response = await axiosInstance.post("/variant/ddlvariant", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setVariantOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };


  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      // required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      // required: true,
      gridClass: "col-lg-4",
    },
    {
      // name: "variant",
      name: "modelId",
      label: "Model",
      placeholder:"",
      type: "dropdown",
      options:modelOptions,
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true }
    },
    {
      // name: "variant",
      name: "variantId",
      label: "Variant",
      placeholder:"",
      type: "dropdown",
      options:variantOptions,
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      
    },
  ];

    useEffect(() => {
        fetchProductList(0, 10);
        }, [filters]);

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
      modelId: filterFormData?.modelId ? filterFormData?.modelId : null,
      variantId: filterFormData?.variantId ? filterFormData?.variantId : null,
    });
  };

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchProductList();
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <div>
            <div className='OnboardManagamentContainer'>
              <div className='OnboardManagamentbuttonContainer'>
                <h5>Grace Period List</h5>
              </div>
              <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
                <div className='topleftdataContainer' style={{ borderRight: "1px solid lightgrey" }} >
                  <h5 className="listTopDataValueText" >{totalData} </h5>
                  <h6>All Record</h6>
                </div>
                <div className='topleftdataContainer' style={{ borderRight: "1px solid lightgrey" }} >
                  <h5 className="listTopDataValueText" >{totalActive} </h5>
                  <h6>Active Record</h6>
                </div>
                <div className='topleftdataContainer'>
                  <h5 className="listTopDataValueText" >{totalInactive} </h5>
                  <h6>Inactive Record</h6>
                </div>
                <button className='addcustomerbutton' onClick={() => navigate('/sales/manage-warranty/grace-period-list/add')}>
                  Add Grace Period
                </button>
              </div>
            </div>
            <div className='tableWrapper'>
              <div className='admin-list-container'>
                <div className='listsearchContainer'>
                  <h5>Grace Period List</h5>
                  <div>
                    <SearchInput
                      placeholder="Search"
                      onSearch={fetchProductList}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />

                  </div>
                     <ListLogisticsFilters
            formConfig={PhysicalStockTakingInputs}
            formData={filterFormData}
            setFormData={setFilterFormData}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            handleSearch={handleSearch}
            handleClear={clearFilter}
          />

                </div>

              </div>
              <CustomTable
                data={productData}
                headers={TABLE_HEADERS}
                keyMapping={keyMapping}
                itemsPerPage={10}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onEdit={handleEdit}
                totalRecords={totalRecords}
              />
            </div>
          </div>
        )}
      </div></>
  );
};

export default GracePeriodList;
